import { EventEmitter } from "events";
import { v4 as uuidv4 } from "uuid";

/**
 * Websocket Client
 * @param {string} uri
 */
export default function WebsocketJS(uri) {
    const _uri = uri;
    const _emitter = new EventEmitter();
    const _callbacks = {};
    let autoReconnection = true;
    let sock;
    let autoPing;

    function sendAutoPing() {
        if (sock) {
            sock.send(JSON.stringify({ type: "message", event: "ping" }));
        }
    }

    function resetIntervalAutoPing() {
        if (autoPing) clearInterval(autoPing);

        autoPing = setInterval(sendAutoPing, 30000);
    }

    function onOpen() {
        _emitter.emit("open");

        resetIntervalAutoPing();
    }

    function onMessage(rawMessage) {
        let _msg = null;

        try {
            _msg = JSON.parse(rawMessage.data);
        } catch (error) {
            console.error("Websocket Client :: Error parsing message");
            return;
        }

        if (_msg) {
            // if (!_msg.hasOwnProperty("type")) {
            //     console.error("Websocket Client :: Invalid message - Missing type");
            //     return;
            // }

            // eslint-disable-next-line no-prototype-builtins
            if (_msg.hasOwnProperty("callback_id")) {
                if (_msg.data?.error)
                    _callbacks[_msg.callback_id].call(
                        null,
                        null,
                        _msg.data.error
                    );
                else _callbacks[_msg.callback_id].call(null, _msg.data);
            } else {
                _emitter.emit(_msg.event, _msg.data, _msg.room);
            }
        } else {
            console.error("Websocket Client :: Error parsing message");
        }
    }

    function onClose() {
        _emitter.emit("close");

        if (autoPing) clearInterval(autoPing);

        if (autoReconnection) {
            setTimeout(() => {
                try {
                    // eslint-disable-next-line no-undef
                    sock = new WebSocket(_uri);
                    sock.onopen = onOpen;
                    sock.onmessage = onMessage;
                    sock.onclose = onClose;
                } catch (err) {
                    console.error("Websocket Client :: AutoReconnection", err);
                }
            }, 1000);
        }
    }

    /**
     * Emit event
     * @param {string} event
     * @param {object} data
     * @param {*} callback
     */
    this.emit = (event, data, callback) => {
        const _msg = {
            type: "message",
            event,
            data,
        };

        if (typeof callback === "function") {
            const callbackId = uuidv4();
            _callbacks[callbackId] = callback;
            _msg.callback_id = callbackId;
        }

        if (sock) {
            sock.send(JSON.stringify(_msg));
        }
    };

    /**
     * Listen event
     * @param {string} event
     * @param {*} listener
     * @returns
     */
    this.on = (event, listener) => {
        return _emitter.on(event, listener);
    };

    /**
     * Remove listener for event
     * @param {string} event
     * @param {*} listener
     * @returns
     */
    this.removeListener = (event, listener) => {
        return _emitter.removeListener(event, listener);
    };

    /**
     * Remove all listeners for event
     * @param {string} event
     * @returns
     */
    this.removeAllListeners = (event) => {
        return _emitter.removeAllListeners(event);
    };

    /**
     * Close connection
     */
    this.close = () => {
        autoReconnection = false;
        if (sock) sock.close();
    };

    try {
        // eslint-disable-next-line no-undef
        sock = new WebSocket(_uri);
        sock.onopen = onOpen;
        sock.onmessage = onMessage;
        sock.onclose = onClose;
    } catch (err) {
        console.error("Websocket Client :: ", err);
    }
}
